






import {Component, Mixins} from 'vue-mixin-decorator';
import {Prop} from 'vue-property-decorator';

import {BaseComponent} from '@/mixins/BaseComponent';

@Component({
  components: {},
})
export default class JsonEditor extends Mixins<BaseComponent>(BaseComponent) {

  @Prop()
  private code: string = '';

}
